import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle, faTimes} from '@fortawesome/free-solid-svg-icons';
import i18next from 'i18next';

class CheckPassword extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hidden: true,
      windowWidth: 0,
      activeShow: false,
    };
    this.toggleShow = this.toggleShow.bind(this);
    this.update = this.update.bind(this);
    window.addEventListener('resize', this.update);
  }

  componentDidMount() {
    this.update();
    if (this.props.history.location.state !== undefined) {
      this.setState({activeShow: this.props.history.location.state.show});
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.update);
  }

  update() {
    this.setState({
      windowWidth: window.innerWidth,
    });
  }

  toggleShow() {
    this.setState({hidden: !this.state.hidden});
  }

  render() {
    const {windowWidth, activeShow} = this.state;
    return (
      <React.Fragment>
        {windowWidth > 767 ?
          <div className={'check-password-desktop'}>
            <div>
              <div className={'header-popup flex space-between '}>
                <p className={'p0 accent-color m-0'}>{i18next.t('Password')}</p>
                <div>
                  <FontAwesomeIcon icon={faTimes}
                    className={'light-grey pointer'}
                    onClick={() => this.props.history.push('/')}
                  />
                </div>
              </div>
              <div className={'body-popup controla-email center '}>
                <FontAwesomeIcon icon={faCheckCircle} className={'check-circle'} />
                <p id={'controlla'} className={'ptb-10 m-0'}>{i18next.t('Controlla la mail sul tuo indirizzo di posta!')}</p>

                <div className={'button'}>
                  <div className={'button-act'} onClick={() =>
                    this.props.history.push('/')}
                  >{i18next.t('CHIUDI')}</div>
                </div>
              </div>
              <div className={'footer-popup '}>
                <p className={'p0 text-footer-d'}>{i18next.t('Non hai ricevuto l\'email? Contatta')}{' '}<span>{i18next.t('l\'assistenza')}</span></p>
              </div>
            </div>
          </div> :
          <div className={'check-password-mobile ' +
          (activeShow ? 'active' : '')}>
            <div>
              <div className={'header-popup flex space-between '}>
                <p className={'p0 m-0 light-grey p20 password'}>{i18next.t('Password mobile')}</p>
                <div>
                  <FontAwesomeIcon icon={faTimes}
                    className={'light-grey pointer'}
                    onClick={() => this.props.history.push('/')}
                  />
                </div>
              </div>
              <div className={'body-popup controla-email center '}>
                <FontAwesomeIcon icon={faCheckCircle} className={'check-circle'} />
                <p className={'ptb-10 m-0'}>{i18next.t('Controlla la mail sul tuo indirizzo di posta!')}</p>

                <div className={'button-wrapper dimenticato2'}>
                  <div className={'button'}
                    onClick={() =>
                      this.props.history.push('/reset-password')}
                  >{i18next.t('CHIUDI')}</div>
                </div>
              </div>
              <div className={'footer-popup '}>
                <p className={'p0 text-footer-m'}>{i18next.t('Non hai ricevuto l\'email? Contatta')}{' '}<span>{i18next.t('l\'assistenza')}</span></p>
              </div>
            </div>
          </div>
        }
      </React.Fragment>
    );
  }
}

export default CheckPassword;
